<template>
  <button v-on="$listeners">
    <slot />
  </button>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '@/scss/_buttons.scss';

.button.is-blue.is-outlined {
  &:hover {
    color: #007aff;
    background: rgba(0, 122, 255, 0.1);
  }
}
</style>
